export default __webpack_public_path__ + "static/media/manageac_navicon-light.e6fe9333.svg";